import moment from "moment";

export const getDateFromUnixTimeStamp = (UnixTimeStamp, dateFormat) => {
  let humanDate = moment.unix(UnixTimeStamp).utc().format(dateFormat);
  let data = humanDate.split(" ");
  return data;
};

/*
 * Returns the readable date time from the utc date string
 *
 * Parameters:
 * inputDate - utc date string
 * Returns:
 * date string
 */

export const getUTCDateTime = (inputDate) => {
  let settDateTime = "";
  if (inputDate) {
    if (typeof inputDate === "number") {
      settDateTime = getDateFromUnixTimeStamp(inputDate, "M/D/YYYY")[0];
    } else {
      settDateTime = moment(inputDate).isValid()
        ? moment(inputDate).utc().format("M/D/YYYY h:mm A")
        : inputDate;
    }
  }
  return settDateTime;
};
